import { useCallback, useMemo } from 'react'
import { ProgressReportByTeamPageConfig } from '../../../../../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { ProcessTreeSelect } from '../../../../ProjectPlanSelect/ProcessTreeSelect'
import { TeamTreeSelect } from '../../../../TeamSelect/TeamTreeSelect'
import { usePageConfigHandlers } from '../hooks/usePageConfigHandlers'
import {
  ConfigContainer,
  SectionContent,
  FormSection,
  FormLabel,
  PageTitleInput,
} from '../styles'
import { VersionReportVersionPageFormModel } from '../../../model/VersionReportVersionPageFormModel'

type ConfigFormProps = {
  page: VersionReportVersionPageFormModel
  snapshotUuid: string
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportVersionPageFormModel
    ) => VersionReportVersionPageFormModel
  ) => void
}

export const ProgressReportByTeamConfigForm = ({
  page,
  snapshotUuid,
  onUpdate,
}: ConfigFormProps) => {
  const config = useMemo(
    () => page.config as ProgressReportByTeamPageConfig,
    [page.config]
  )

  const { handlePageTitleChange } = usePageConfigHandlers(page, onUpdate)

  const handleRootUuidChange = useCallback(
    (uuids: string[]) => {
      onUpdate(page.pageNumber, prevEntity => {
        const currentConfig =
          prevEntity.config as ProgressReportByTeamPageConfig
        return {
          ...prevEntity,
          config: {
            ...currentConfig,
            rootUuid: uuids[0],
          },
        }
      })
    },
    [onUpdate, page.pageNumber]
  )

  const handleTeamUuidsChange = useCallback(
    (uuids: string[]) => {
      onUpdate(page.pageNumber, prevEntity => {
        const currentConfig =
          prevEntity.config as ProgressReportByTeamPageConfig
        return {
          ...prevEntity,
          config: {
            ...currentConfig,
            tableRows: uuids,
          },
        }
      })
    },
    [onUpdate, page.pageNumber]
  )

  return (
    <ConfigContainer>
      <SectionContent>
        <FormSection>
          <PageTitleInput
            label="ページタイトル"
            value={page.pageTitle}
            onChange={handlePageTitleChange}
            placeholder="ページのタイトルを入力してください"
            variant="outlined"
            required={true}
          />
        </FormSection>
        <FormSection>
          <FormLabel>集計基準となる工程を選択してください</FormLabel>
          <ProcessTreeSelect
            key={page.pageNumber}
            snapshotUuid={snapshotUuid}
            value={config.rootUuid ? [config.rootUuid] : []}
            onChange={handleRootUuidChange}
            multiSelect={false}
          />
        </FormSection>

        <FormSection>
          <FormLabel>集計対象のチームを選択してください</FormLabel>
          <TeamTreeSelect
            key={page.pageNumber}
            snapshotUuid={snapshotUuid}
            value={config.tableRows}
            onChange={handleTeamUuidsChange}
          />
        </FormSection>
      </SectionContent>
    </ConfigContainer>
  )
}
